import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import {colorBlueBlack as color} from './Mui/styles';


class InnerBar extends React.PureComponent {
  render() {
    const { text, ...other } = this.props

    return(
      <AppBar
        position="relative"
        style={{
          height: 40,
          backgroundColor: color
        }}
        {...other}>
        <Toolbar style={{
          minHeight: 40,
        }}>
          <Typography className="c-white087 h6">
            {text}
          </Typography>
        </Toolbar>
      </AppBar>
    )
  }
}

export default InnerBar



// WEBPACK FOOTER //
// ./src/js/components/InnerBar.js